import { render, staticRenderFns } from "./BTextarea.vue?vue&type=template&id=6b58f97c&"
import script from "./BTextarea.vue?vue&type=script&lang=js&"
export * from "./BTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports